import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import {
  Aangever,
  Aangifte, BokkzAlgDataService, IncomeTaxEntity,
  OmschrijvingEnBedrag,
  PGASpecifiekeZorgkosten
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SPINNER_TIMEOUT} from "../../../gedeelde-componenten/gedeelde-componenten.component";
import { filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'snelstart-venture-fiscaal-feature-kosten-extra-gezinshulp',
  templateUrl: './kosten-extra-gezinshulp.component.html',
  styleUrls: ['./kosten-extra-gezinshulp.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class KostenExtraGezinshulpComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;

    @Input() public id!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    private focusedElementId: string | null = null;

    public kostenExtraGezinshulp = {} as FormGroup

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.kostenExtraGezinshulp = this.fb.group({
            pgaKostenExtraGezinshulp:
                this.fb.array<PGASpecifiekeZorgkosten>([])
        })
    }

    get pgaKostenExtraGezinshulp(): FormArray {
        return this.kostenExtraGezinshulp.get('pgaKostenExtraGezinshulp') as FormArray;
    }

    addRijKostenExtraGezinshulp(): void {
        this.pgaKostenExtraGezinshulp.push(this.createKostenExtraGezinshulpFormGroup()
        )
    }

    verwijderRijKostenExtraGezinshulp(index: number): void {
        this.pgaKostenExtraGezinshulp.removeAt(index);
        this.kostenExtraGezinshulp.updateValueAndValidity()
        this.kostenExtraGezinshulp.markAsDirty()
        this.saveForm()
    }



    createKostenExtraGezinshulpFormGroup(kosten?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: kosten ? kosten.omschrijving : undefined,
            bedrag: kosten ? kosten.bedrag : undefined
        } as OmschrijvingEnBedrag));
    }

    public ngOnInit(): void {
       this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.updateForm()
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.kostenExtraGezinshulp.dirty;
  }

  private updateForm(): void {
        const kostenExtraGezinshulpLijst = this.aangifte?.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten?.kostenExtraGezinshulp || [];
        const formArray = this.kostenExtraGezinshulp.get('pgaKostenExtraGezinshulp') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > kostenExtraGezinshulpLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Add or update controls
        for (let i = 0; i < kostenExtraGezinshulpLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(kostenExtraGezinshulpLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createKostenExtraGezinshulpFormGroup(kostenExtraGezinshulpLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                persoonsgebondenAftrek: {
                    ...this.aangifte.persoonsgebondenAftrek,
                    pgaSpecifiekeZorgkosten: {
                        ...this.aangifte.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten,
                        kostenExtraGezinshulp: this.kostenExtraGezinshulp.value.pgaKostenExtraGezinshulp
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
    }
}
